import { PosNoEnterCreditRequestReasonModalComponent } from './pos-no-enter-credit-request-reason-modal.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PosListModule } from '../pos-list/pos-list.module';



@NgModule({
  declarations: [PosNoEnterCreditRequestReasonModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PosListModule
  ],
  exports:[PosNoEnterCreditRequestReasonModalComponent]
})
export class PosNoEnterCreditRequestReasonModalModule { }
